var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.6466 11.5859C7.77425 11.7135 7.95374 11.7577 8.11729 11.7185C8.20407 11.6977 8.28638 11.6535 8.3541 11.5858L11.3943 8.54531C11.4724 8.46721 11.4724 8.34058 11.3943 8.26247L10.7932 7.66143C10.7151 7.58332 10.5885 7.58332 10.5104 7.66143L8.62506 9.54675L8.62506 2.09258C8.62506 1.98212 8.53552 1.89258 8.42506 1.89258H7.57506C7.4646 1.89258 7.37506 1.98212 7.37506 2.09258L7.37506 9.54608L5.49032 7.66133C5.41222 7.58323 5.28558 7.58323 5.20748 7.66133L4.60644 8.26238C4.52833 8.34048 4.52833 8.46711 4.60644 8.54522L7.6466 11.5859ZM2.32501 14.1089C2.04887 14.1089 1.82501 13.885 1.82501 13.6089V11.1839C1.82501 11.0734 1.91456 10.9839 2.02501 10.9839H2.87501C2.98547 10.9839 3.07501 11.0734 3.07501 11.1839V12.8589H12.925V11.1839C12.925 11.0734 13.0146 10.9839 13.125 10.9839H13.975C14.0855 10.9839 14.175 11.0734 14.175 11.1839V13.6089C14.175 13.885 13.9512 14.1089 13.675 14.1089H2.32501Z",
    fill: "#863DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a0dd74d25de8d8a6db6b91c158376663.svg";
export { ForwardRef as ReactComponent };